import ReducerRegistry from '../base/redux/ReducerRegistry';
import { SET_PICTURE_IN_PICTURE_ENABLED, SET_PICTURE_IN_PICTURE_OBJECT } from './actionTypes';
const DEFAULT_STATE = {
    pip: false,
    pipObject: {},
};
/**
 * Reduces the Redux actions of the feature features/face-recognition.
 */
ReducerRegistry.register('features/picture-in-picture', (state = DEFAULT_STATE, action) => {
    const { pip, pipObject } = action;
    switch (action.type) {
        case SET_PICTURE_IN_PICTURE_ENABLED:
            return Object.assign(Object.assign({}, state), { pip });
        case SET_PICTURE_IN_PICTURE_OBJECT:
            return Object.assign(Object.assign({}, state), { pipObject });
        default:
            return state;
    }
});
